import ActionTypes, { LorawanActionTypes } from '@utils/deviceActions';
import { TFunction } from 'i18next';
import { modelValuesByDataIndex } from './modelValuesByDataIndex';
import loraWanModels from './loraWanModels';
import simCardModels from './simCardModels';

type UploadColumnProps = {
  title: string;
  dataIndex: string;
  key: string;
  validation?: { type: string; length?: number };
};

const DEFAULT_NUMBER_OF_LINES = 3;

// msisdn:newMsisdn ---> newMsisdn
const handleAlternativeDataIndex = (dataIndex: string) => {
  const dataIndexSplit = dataIndex.split(':');
  if (dataIndexSplit?.length === 2) {
    return dataIndexSplit;
  }
  return [dataIndex, dataIndex];
};

interface UploadModelsProps {
  t: TFunction;
  actionKey: ActionTypes | LorawanActionTypes | undefined;
  columnsNames?: string[];
  isLoraWan?: boolean;
  isMotBusiness?: boolean;
  hasNewLora?: boolean;
}

export const getUploadModels = ({
  t,
  actionKey,
  columnsNames,
  isLoraWan,
  isMotBusiness,
  hasNewLora,
}: UploadModelsProps) => {
  let actionDataIndexList: string[] = columnsNames ?? [];
  if (!columnsNames) {
    if (isLoraWan) {
      actionDataIndexList = loraWanModels(
        actionKey as LorawanActionTypes,
        hasNewLora,
      );
    } else {
      actionDataIndexList = simCardModels(
        actionKey as ActionTypes,
        isMotBusiness,
      );
    }
  }

  const actionModel: { columns: UploadColumnProps[]; data: any[] } = {
    columns: [],
    data: [],
  };

  // feeds the columns
  actionDataIndexList.forEach(dataIndex => {
    const [nameDataIndex, keyDataIndex] = handleAlternativeDataIndex(dataIndex);

    actionModel.columns.push({
      key: keyDataIndex,
      title: t(`${isLoraWan ? 'lorawan' : 'attributes'}:${nameDataIndex}`),
      dataIndex: keyDataIndex,
    });
  });

  // feeds data
  Object.keys(new Array(DEFAULT_NUMBER_OF_LINES).fill(null)).forEach(key => {
    const dataModel: { [key: string]: any } = {};
    actionDataIndexList?.forEach(dataIndex => {
      const [nameDataIndex, keyDataIndex] =
        handleAlternativeDataIndex(dataIndex);
      dataModel[keyDataIndex] =
        // @ts-ignore
        modelValuesByDataIndex()?.[nameDataIndex]?.[key];
    });
    actionModel.data.push({
      key,
      ...dataModel,
    });
  });

  return actionModel;
};
